/**
 * Logger Utility
 *
 * Conditional logging that only outputs in development mode.
 * Provides consistent logging interface across the application.
 */

const isDevelopment = import.meta.env.DEV;

/**
 * Log informational messages (only in development)
 */
export function logInfo(message: string, ...args: unknown[]): void {
  if (isDevelopment) {
    // eslint-disable-next-line no-console -- this module is the sanctioned console boundary
    console.log(`[INFO] ${message}`, ...args);
  }
}

/**
 * Log warning messages (only in development)
 */
export function logWarning(message: string, ...args: unknown[]): void {
  if (isDevelopment) {
    console.warn(`[WARN] ${message}`, ...args);
  }
}

/**
 * Log error messages (always logged, even in production)
 */
export function logError(message: string, ...args: unknown[]): void {
  console.error(`[ERROR] ${message}`, ...args);
}

/**
 * Log debug messages (only in development)
 */
export function logDebug(message: string, ...args: unknown[]): void {
  if (isDevelopment) {
    // eslint-disable-next-line no-console -- this module is the sanctioned console boundary
    console.debug(`[DEBUG] ${message}`, ...args);
  }
}
